import { useMemo } from "react";
import { useSyncedResource } from "hooks/useSyncedResource.hook";
import * as SCOPE from "services/sync/scope";
import useInfrastructure from "hooks/useInfrastructure.hook";
import * as conversationsSync from "services/sync/resources/chat/conversations.sync";

export function useChatConversationsUnassigned({ enabled = true, lineId } = {}) {
  const { syncEngine, repositories } = useInfrastructure();
  const repository = repositories.conversations;

  const status = 'UNASSIGNED';

  enabled = enabled && !!lineId;
  const scope = SCOPE.CHAT.CONVERSATIONS_UNASSIGNED;
  const key = useMemo(() => `(lineId:${lineId})-(status:${status})`, [lineId]);
  const syncParams = useMemo(() => ({ status }), []);

  return useSyncedResource({
    enabled,
    scope,
    key,
    cacheFn: ({ scope, key }) => repository.getFromCache(scope, key, () => repository.getByLineIdStatus(lineId, status)),
    syncParams,
    syncFn: conversationsSync.unassigned,
    syncEngine,
    repository,
    repositories,
    deps: [lineId]
  });
}
